/* External */
import { createContext, useContext, useMemo } from 'react';

export const TermsOfServiceContext = createContext({
  termsOfService: undefined,
  isLoading: false,
  shouldAccept: false,
});

export function useTermsOfServiceInfo() {
  const {
    currentPath,
    setCurrentPath,
    termsOfService,
    isLoading,
    shouldAccept,
    isLoadingShouldAccept,
    performShouldUserAcceptNewTerms,
    acceptNewTerms,
  } = useContext(TermsOfServiceContext);
  return useMemo(() => ({
    currentPath,
    setCurrentPath,
    termsOfService: termsOfService?.toJS(),
    isLoading,
    shouldAccept,
    isLoadingShouldAccept,
    performShouldUserAcceptNewTerms,
    acceptNewTerms,
  }), [
    currentPath,
    setCurrentPath,
    termsOfService,
    isLoading,
    shouldAccept,
    isLoadingShouldAccept,
    performShouldUserAcceptNewTerms,
    acceptNewTerms,
  ]);
}
